var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationDefault = function SvgNotificationDefault(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.495 20.6026V15.1325C22.495 11.7739 20.7222 8.96226 17.6304 8.21833V7.4744C17.6304 6.56637 16.8953 5.83337 15.9981 5.83337C15.1008 5.83337 14.3873 6.56637 14.3873 7.4744V8.21833C11.2848 8.96226 9.52271 11.7629 9.52271 15.1325V20.6026L8.11737 22.0139C7.43633 22.7031 7.91198 23.8847 8.87409 23.8847H23.1112C24.0733 23.8847 24.5598 22.7031 23.8788 22.0139L22.495 20.6026ZM15.9981 27.1667C17.1872 27.1667 18.1601 26.1821 18.1601 24.9787H13.836C13.836 26.1821 14.7981 27.1667 15.9981 27.1667Z",
    fill: "#5547DD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Notification-Default.4a5a90722e9e93b83072fea921826065.svg";